import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import PostAddIcon from '@material-ui/icons/PostAdd'
import { precargarDatosNominacion } from '../../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CUPO_MULTIPLE } from '../../../../config/forms'

function OperacionesCuposMultiples (props) {
  function onClick () {
    const { cupo } = props
    props.precargarDatosNominacion(cupo)
  }
  return (
    <div>
      <Tooltip title={'Utilizar cupos disponible'}>
        <IconButton onClick={() => onClick()}>
          <PostAddIcon fontSize='default' color='primary' />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const mapStateToProps = (state) => ({
  contacto: state.cupos.contacto
})

const mapActionsToProps = {
  precargarDatosNominacion
}
const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(reduxForm({
  form: FORM_CUPO_MULTIPLE
})(OperacionesCuposMultiples))
